import { apiRequest } from "../util/apiUtils";

export const testimonialsList = async (params) => {
  try {
    const res = await apiRequest("get", `testimonial/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const testimonialsAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `testimonial/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const testimonialsDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `testimonial/delete-all`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const testimonialsStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `testimonial/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
